import React from 'react';

import type { Tab } from '@sravni/ugc/lib/specialOffers/types';

export enum PARAMS_FROM_QUERY {
  isNeedBVersion = 'isNeedBVersion',
  iframeId = 'iframeId',
  abName = 'abName',
  isPopup = 'isPopup',

  isWithButtons = 'isWithButtons',
  isVerticalOnMobile = 'isVerticalOnMobile',

  bonusFilter = 'bonusFilter',
  organizationId = 'organizationId',

  firstTab = 'firstTab',
  subproduct = 'subproduct',
}

export interface ISpecialOffersContext {
  isNeedBVersion: boolean;
  iframeId: string;
  abName: string;
  isPopup: boolean;

  isWithButtons?: boolean;
  isVerticalOnMobile?: boolean;

  bonusFilter: string[];
  organizationId?: string[];

  firstTab?: Tab;
}

export const DEFAULT_OFFERS_PAGE_CONTEXT: ISpecialOffersContext = {
  isNeedBVersion: false,
  iframeId: '',
  abName: '',
  isPopup: false,

  isWithButtons: false,
  isVerticalOnMobile: false,

  bonusFilter: null,
  organizationId: null,

  firstTab: null,
};

export const SpecialOffersContext = React.createContext<ISpecialOffersContext>(DEFAULT_OFFERS_PAGE_CONTEXT);
